export default "__VITE_ASSET__CTlR7qpA__"